<template>
  <div :id="id"></div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themesAnimated from '@amcharts/amcharts4/themes/animated';

/* Chart code */
am4core.options.queue = true;
am4core.useTheme(am4themesAnimated);
am4core.addLicense('CH315878972');
// Themes end

export default {
  props: {
    id: {
      type: String,
      default: 'chartdiv',
    },
    colors: {
      type: Array,
      default: () => ['#f799d1', '#e04074'],
    },
    data: {
      type: Array,
      default: () => [
        {
          name: 'Orkney Islands',
          value: 45688,
        },
        {
          name: 'Aberdeenshre',
          value: 35781,
        },
        {
          name: 'Moray',
          value: 25464,
        },
        {
          name: 'Perth and Kinross',
          value: 18788,
        },
      ],
    },
    yAxis: {
      type: Object,
      default: () => ({
        label: 'name',
      }),
    },
    xAxis: {
      type: Object,
      default: () => ({
        label: 'value',
      }),
    },
  },
  mounted() {
    const chartContainer = document.getElementById(this.id);
    chartContainer.style.width = '100%';
    chartContainer.style.height = '15em';
    const chart = am4core.create(this.id, am4charts.XYChart);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chart.paddingRight = 40;

    chart.data = this.data;

    const categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = this.yAxis.label;
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.renderer.minGridDistance = 10;
    categoryAxis.renderer.fontSize = 20;

    const valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = 'Route length (miles) per 10,000 people';
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.fillOpacity = 1;
    valueAxis.renderer.grid.template.strokeOpacity = 1;
    valueAxis.renderer.baseGrid.disabled = true;
    valueAxis.numberFormatter.numberFormat = '##.##';

    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueX = this.xAxis.label;
    series.dataFields.categoryY = this.yAxis.label;
    series.columnsContainer.zIndex = 100;

    const columnTemplate = series.columns.template;
    columnTemplate.height = am4core.percent(80);
    columnTemplate.strokeOpacity = 0;

    columnTemplate.adapter.add('fill', (fill, target) => {
      let newColour = fill;
      if (target.dataItem) {
        switch (target.dataItem.categoryY) {
          case 'Perth':
            newColour = am4core.color('#00b0db');
            break;
          case 'Inverness':
            newColour = am4core.color('#d4d0c7');
            break;
          case 'Stirling':
            newColour = am4core.color('#fdc300');
            break;
          case 'Glasgow':
            newColour = am4core.color('#6fbc85');
            break;
          case 'Edinburgh':
            newColour = am4core.color('#ed6d91');
            break;
          case 'Dundee':
            newColour = am4core.color('#143c6a');
            break;
          default:
            newColour = fill;
        }
        return newColour;
      }
      return newColour;
    });

    // series.heatRules.push({
    //   target: columnTemplate,
    //   property: 'fill',
    //   dataField: 'valueX',
    //   min: am4core.color(this.colors[0]),
    //   max: am4core.color(this.colors[1]),
    // });

    const bullet = series.bullets.push(new am4charts.LabelBullet());
    bullet.label.text = `{${this.xAxis.label}}`;
    bullet.label.fontsize = 20;
    bullet.label.truncate = false;
    bullet.label.hideOversized = true;
    bullet.label.horizontalCenter = 'right';
    bullet.label.fill = 'black';
    bullet.label.fontWeight = 'bold';
    bullet.label.dx = -10;
    chart.responsive.useDefault = false;
    chart.responsive.enabled = true;
    chart.responsive.rules.push({
      relevant(target) {
        if (target.pixelWidth <= 400) {
          return true;
        }
        return false;
      },
      state(target, stateId) {
        if (target instanceof am4charts.AxisRendererY) {
          const state = target.states.create(stateId);
          state.properties.fontSize = 12;
          return state;
        }
        if (target instanceof am4charts.LabelBullet) {
          const state = target.states.create(stateId);
          state.properties.fontSize = 12;
          return state;
        }
        return null;
      },
    });
  },
};
</script>

<style></style>
